import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoePrints } from '@fortawesome/free-solid-svg-icons';

const translations = {
  es: {
    claim: (
      <>
        Te ayudamos a hacer el primer paso{' '}
        <FontAwesomeIcon icon={faShoePrints} style={{ color: '#ff2300' }} />
      </>
    ),
    description:
      'Nuestro acompañamiento te asegura el éxito de implementar nuestra herramienta',
    stats: [
      {
        value: '9/10',
        label: 'clientes',
        detail: 'destacaron lo fácil que fue de implantar',
      },
      {
        value: '4.65/5',
        label: 'puntuación',
        detail: 'valoración de los usuarios de nuestra app',
      },
      {
        value: '91%',
        label: 'de los clientes',
        detail: 'afirman que han cambiado sus hábitos con Bether',
      },
    ],
    testimonial: {
      intro: 'Por qué a los clientes les encanta',
      text: '"...va a permitirte a ti y a tu equipo alcanzar niveles que no pensabas que fueran posibles..."',
    },
  },
  en: {
    claim: (
      <>
        We help you take the first step{' '}
        <FontAwesomeIcon icon={faShoePrints} style={{ color: '#ff2300' }} />
      </>
    ),
    description: 'Our support ensures the success of implementing our tool',
    stats: [
      {
        value: '9/10',
        label: 'clients',
        detail: 'highlighted how easy it was to implement',
      },
      {
        value: '91%',
        label: 'of clients',
        detail: 'state that they have changed their habits with Bether',
      },
      { value: '4.65/5', label: 'rating', detail: 'user rating of our app' },
    ],
    testimonial: {
      intro: 'Why customers love',
      text: '"...it\'s going to allow you and your team to reach levels you didn\'t think were possible..."',
    },
  },
};

function Recursos({ language }) {
  const { claim, description, stats, testimonial } = translations[language];

  const renderStatValue = (value) => {
    const parts = value.split(/(?=[/%])/);
    return (
      <>
        <span style={styles.bigValue}>{parts[0]}</span>
        <span style={styles.smallValue}>{parts[1]}</span>
      </>
    );
  };

  return (
    <>
      <section style={styles.section}>
        <div style={styles.contentBox}>
          <p style={styles.claim}>{claim}</p>
          <p style={styles.description}>{description}</p>
          <div style={styles.statsContainer}>
            {stats.map((stat, index) => (
              <div key={index} style={styles.statBox}>
                <div style={styles.statValue}>
                  {renderStatValue(stat.value)}
                </div>
                <div style={styles.statLabel}>{stat.label}</div>
                <p style={styles.statDetail}>{stat.detail}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Sección testimonial con fondo blanco ocupando toda la pantalla */}
      <section style={styles.testimonialSection}>
        <div style={styles.testimonialContent}>
          <p style={styles.testimonialIntro}>
            {testimonial.intro}{' '}
            <img
              src="/BetherLogoLuminousOrange.png"
              alt="Bether Logo"
              style={styles.logo}
            />
          </p>
          <blockquote style={styles.testimonialText}>
            {testimonial.text}
          </blockquote>
        </div>
      </section>
    </>
  );
}

const styles = {
  section: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f9f9f9',
    padding: '40px 20px',
    marginBottom: '60px',
  },
  contentBox: {
    maxWidth: '800px',
    textAlign: 'center',
  },
  claim: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#333',
    marginBottom: '10px',
    marginTop: '30px',
  },
  description: {
    fontSize: '18px',
    color: '#555',
    marginBottom: '30px',
    fontWeight: '400',
  },
  statsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
    gap: '20px',
  },
  statBox: {
    backgroundColor: '#fff',
    border: '1px solid #ddd',
    borderRadius: '15px',
    padding: '10px',
    width: '200px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  statValue: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'center',
    marginBottom: '0px',
  },
  bigValue: {
    fontSize: '50px',
    fontWeight: '700',
    color: '#111',
  },
  smallValue: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#111',
    marginLeft: '2px',
  },
  statLabel: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#333',
    margin: '-15px 0 15px',
  },
  statDetail: {
    fontSize: '12px',
    color: '#666',
    fontWeight: '400',
  },

  // Estilos para la sección testimonial (pantalla completa)
  testimonialSection: {
    backgroundColor: '#ffffff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '40px 20px',
    marginBottom: '40px',
  },
  testimonialContent: {
    maxWidth: '800px',
    textAlign: 'center',
  },
  testimonialIntro: {
    fontSize: '16px',
    color: '#333',
    fontWeight: '500',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
  },
  logo: {
    height: '14px',
    verticalAlign: 'middle',
  },
  testimonialText: {
    fontSize: '45px',
    fontWeight: '300',
    color: '#222',
    fontStyle: 'italic',
    margin: '20px 0',
    lineHeight: '1.4',
  },
};

export default Recursos;
